<template>
    <div v-if="mounted">
        <template v-if="visualizationType === 'pojedynczy'">
            <form-layer-style-line-single-symbol v-bind:size="size" @updated="updateValue" @errorMessage="setError" ref="singleSymbol" />
        </template>
        <template v-else-if="visualizationType === 'unikalny'">
            <form-layer-style-line-unique-value v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="size" @updated="updateValue" @errorMessage="setError" ref="uniqueValue" />
        </template>
        <template v-else-if="visualizationType === 'stopniowy'">
            <form-layer-style-line-gradual-symbol v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="size" @updated="updateValue" @errorMessage="setError" ref="gradualSymbol" />
        </template>
    </div>
</template>

<script>
import FormLayerStyleLineGradualSymbol from "./line/FormLayerStyleLineGradualSymbol.vue";
import FormLayerStyleLineSingleSymbol from "./line/FormLayerStyleLineSingleSymbol.vue";
import FormLayerStyleLineUniqueValue from "./line/FormLayerStyleLineUniqueValue.vue";
import LayerStyleStore from "./store/LayerStyleStore";

export default {
  name: "FormLayerStyleLine",
  props: {
    visualizationType: String,
    value: Object,
    attributes: Array,
    layerId: String,
    size: String
  },
  data() {
    return {
      singleSymbol: null,
      uniqueValue: null,
      gradualSymbol: null,
      mounted: false
    };
  },
  mounted() {
    let store = new LayerStyleStore();
    const initialValue = store.getLineStyle();
    if (initialValue != null && initialValue.reguly != null) {
      switch (this.visualizationType) {
        case "pojedynczy":
          store.setLineSingleSymbol(initialValue);
          break;
        case "unikalny":
          store.setLineUniqueValue(initialValue);
          break;
        case "stopniowy":
          store.setLineGradualSymbol(initialValue);
          break;
      }
    }
    this.mounted = true;
  },
  methods: {
    updateValue() {
      let store = new LayerStyleStore();
      let emitValue = null;
      switch (this.visualizationType) {
        case "pojedynczy":
          emitValue = store.getLineSingleSymbol();
          break;
        case "unikalny":
          emitValue = store.getLineUniqueValue();
          break;
        case "stopniowy":
          emitValue = store.getLineGradualSymbol();
          break;
      }
      emitValue = emitValue !== null ? emitValue : {};
      emitValue.reguly = emitValue.reguly != null ? emitValue.reguly : [];
      emitValue.typ = this.visualizationType;
      store.setLineStyle(emitValue);
      this.$emit('updated');
    },
    validate() {
      switch (this.visualizationType) {
        case "pojedynczy":
          return this.$refs.singleSymbol.validate();
        case "unikalny":
          return this.$refs.uniqueValue.validate();
        case "stopniowy":
          return this.$refs.gradualSymbol.validate();
      }
    },
    setError(args) {
      this.$emit('errorMessage', args);
    }
  },
  components: {
    FormLayerStyleLineGradualSymbol,
    FormLayerStyleLineSingleSymbol,
    FormLayerStyleLineUniqueValue
  }
};
</script>